import { AccountRegistrationStatus } from '@paladin-monorepo/common';
import type { UserProps } from './auth';
import { isSystemAdmin } from './permissions';

export function userNeedsRegistrationGate(user?: UserProps | null): boolean {
  if (!user || isSystemAdmin(user)) return false;
  const status = user.account?.registrationStatus;
  return (
    status === AccountRegistrationStatus.Pending ||
    status === AccountRegistrationStatus.Rejected
  );
}

export function userRegistrationPending(user?: UserProps | null): boolean {
  if (!user || isSystemAdmin(user)) return false;
  return user.account?.registrationStatus === AccountRegistrationStatus.Pending;
}

export function userRegistrationRejected(user?: UserProps | null): boolean {
  if (!user || isSystemAdmin(user)) return false;
  return user.account?.registrationStatus === AccountRegistrationStatus.Rejected;
}
